module.exports = __webpack_public_path__ + "static/img/can-peach.04eee40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-peach.png
// module id = xHhe
// module chunks = 0